import React from 'react';

/**
 * DeviceSection Component
 * 
 * "Coming Soon" section for hardware device integration.
 * 
 * Exact styles from landing.css:
 * - Device card padding: 3rem 2.5rem (48px 40px)
 * - Border radius: 24px
 * - Badge with pulse animation
 * - Device title: 2.5rem (40px)
 * - Device description: 1.1rem (17.6px)
 */
const DeviceSection = () => {
  return (
    <section id="devices" className="device-integration py-section-mobile md:py-section-tablet lg:py-section-desktop px-4 md:px-6 lg:px-8 max-w-section mx-auto relative z-content opacity-0 animate-fade-in-up-landing">
      <div
        className="device-card p-4 md:p-8 lg:p-12 rounded-device-card glass-bg-card transition-all duration-300 shadow-device-card relative overflow-hidden text-center group hover:-translate-y-2 hover:shadow-device-card-hover hover:border-white/20"
      >
        {/* Card overlays on hover */}
        <div className="absolute top-0 left-0 w-full h-full bg-card-overlay opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
        <div className="absolute -top-1/2 -left-1/2 w-[200%] h-[200%] bg-card-radial-overlay opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

        {/* Coming Soon Badge */}
        <span
          className="device-badge inline-block py-2 px-5 rounded-device-badge border text-device-badge font-bold uppercase tracking-[0.1em] mb-6 animate-pulse-badge relative z-10"
          style={{
            background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(99, 102, 241, 0.2))',
            borderColor: 'rgba(59, 130, 246, 0.3)',
            color: '#60a5fa',
          }}
        >
          Coming Soon
        </span>

        {/* Title */}
        <h2 className="device-title text-2xl md:text-3xl lg:text-device-title font-semibold text-text-primary mb-4 md:mb-6 leading-[1.2] relative z-10">
          Hardware Device Integration
        </h2>

        {/* Description */}
        <p className="device-description text-sm md:text-base lg:text-device-description text-text-secondary leading-[1.6] max-w-device-description mx-auto mb-6 md:mb-8 relative z-10">
          We're developing a physical device that integrates with <span className="lawnance-brand">LAWNANCE</span> for seamless on-the-go access to your legal and financial tools. Stay tuned!
        </p>

        {/* Visual placeholder */}
        <div className="device-visual mt-8 flex justify-center items-center relative z-10">
          <div
            className="device-icon-placeholder w-[120px] h-[120px] rounded-full flex items-center justify-center text-text-primary border border-white/10"
            style={{
              background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3), inset 0 0 20px rgba(255, 255, 255, 0.1)',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="opacity-80"
            >
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeviceSection;

